// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ArrowRedLeftInactive: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 12"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="14"
            height="12"
            fill="currentColor"
        >
            <path
                d="M55.0001559,189 C55.0001559,189.553125 54.5805585,190 54.0263135,190 L44.422538,190 L47.7229553,193.29375 C48.114371,193.684375 48.114371,194.317187 47.7229553,194.707812 C47.5256812,194.903125 47.2689126,195 47.0121441,195 C46.7553755,195 46.4992328,194.902344 46.3038384,194.707031 L41.2937177,189.707031 C40.902302,189.316406 40.902302,188.683594 41.2937177,188.292969 L46.3038384,183.292969 C46.6952541,182.902344 47.3293475,182.902344 47.7207632,183.292969 C48.1121788,183.683594 48.1121788,184.316406 47.7207632,184.707031 L44.422538,188 L54.0263135,188 C54.5805585,188 55.0001559,188.446875 55.0001559,189 Z"
                opacity=".66"
                transform="translate(-41 -183)"
            />
        </svg>
    );
};

export default React.memo(ArrowRedLeftInactive);
